import { Router } from '@angular/router';
import { Global } from '../classes/Global';

export class ContextInfoHelper {

  /**
   * Collects comprehensive context information for error reporting
   * @param router Optional router instance for router state information
   * @returns Context information object
   */
  public static collectContextInfo(router?: Router): any {
    const context: any = {};

    try {
      // URL Information
      if (typeof window !== 'undefined' && window.location) {
        context.url = {
          href: window.location.href,
          pathname: window.location.pathname,
          search: window.location.search,
          hash: window.location.hash,
          origin: window.location.origin
        };
      }

      // Router State
      if (router && router.url) {
        context.routerUrl = router.url;
      }

      // Referrer
      if (typeof document !== 'undefined' && document.referrer) {
        context.referrer = document.referrer;
      }

      // Screen/Viewport Information
      if (typeof window !== 'undefined' && window.screen) {
        context.screen = {
          width: window.screen.width,
          height: window.screen.height,
          availWidth: window.screen.availWidth,
          availHeight: window.screen.availHeight,
          colorDepth: window.screen.colorDepth,
          pixelDepth: window.screen.pixelDepth
        };
      }

      // Viewport Size
      if (typeof window !== 'undefined') {
        context.viewport = {
          innerWidth: window.innerWidth,
          innerHeight: window.innerHeight,
          outerWidth: window.outerWidth,
          outerHeight: window.outerHeight
        };
      }

      // Network Status
      if (typeof navigator !== 'undefined') {
        context.networkStatus = {
          onLine: navigator.onLine,
          connection: (navigator as any).connection ? {
            effectiveType: (navigator as any).connection.effectiveType,
            downlink: (navigator as any).connection.downlink,
            rtt: (navigator as any).connection.rtt
          } : 'not available'
        };
      }

      // Application State (Global)
      try {
        context.appState = {
          country: Global.getCountry(),
          store: Global.getStore(),
          mediaType: Global.getMediaType()
        };
      } catch (e) {
        context.appState = 'Error getting app state: ' + e.message;
      }

      // Performance Information (if available)
      if (typeof performance !== 'undefined' && (performance as any).memory) {
        context.performance = {
          memory: {
            usedJSHeapSize: Math.round((performance as any).memory.usedJSHeapSize / 1048576) + ' MB',
            totalJSHeapSize: Math.round((performance as any).memory.totalJSHeapSize / 1048576) + ' MB',
            jsHeapSizeLimit: Math.round((performance as any).memory.jsHeapSizeLimit / 1048576) + ' MB'
          }
        };
      }

      // Timestamp (more precise)
      try {
        let timezone = 'unknown';
        if (typeof Intl !== 'undefined' && Intl.DateTimeFormat) {
          try {
            const resolvedOptions = Intl.DateTimeFormat().resolvedOptions();
            if (resolvedOptions && resolvedOptions.timeZone) {
              timezone = resolvedOptions.timeZone;
            }
          } catch (e) {
            // Intl.DateTimeFormat().resolvedOptions() or timeZone not available (old browsers)
            timezone = 'not available';
          }
        } else {
          // Intl API not available (very old browsers)
          timezone = 'not available';
        }
        context.errorTimestamp = {
          iso: new Date().toISOString(),
          timestamp: Date.now(),
          timezone: timezone
        };
      } catch (e) {
      // Fallback if timestamp creation fails
        context.errorTimestamp = {
          iso: new Date().toISOString(),
          timestamp: Date.now(),
          timezone: 'error: ' + (e.message || String(e))
        };
      }

    } catch (e) {
      context.collectionError = 'Error collecting context: ' + e.message;
    }

    return context;
  }

}

